import Card from "components/Card/Card";
import Chart from "react-apexcharts";

const ChartBar = ({ data }) => {
    return (
        <Card
            py="1rem"
            height={{ sm: "280px" }}
            width="100%"
            bg="#E53E3E"
            position="relative"
        >
            <Chart
                options={data.options}
                series={data.series}
                type="bar"
                width="100%"
                height="100%"
            />
        </Card>
    );
}

export default ChartBar;